import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation } from "./EntityCommandInformation";
import { PartialNullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";
import { Property } from "./RadObject";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { PageManager } from "./Ui/PageManager";

export type EntityCommandOpenPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandOpenProperties = {
    [name in keyof EntityCommandOpenPropertyValues]: Property<EntityCommandOpenPropertyValues[name]>
};

export interface IEntityCommandOpen extends IEntityCommand, EntityCommandOpenProperties
{
}

export class EntityCommandOpen extends EntityCommand<EntityCommandOpenPropertyValues> implements IEntityCommandOpen
{
    public static override classNamespace = NAMESPACE + "EntityCommandOpen";
    public static override className = "EntityCommandOpen";

    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandOpenPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Open",
                isDefault: true,
                key: "OPEN",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandOpenPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        record = entityCommandInformation.record.get();

                    return (
                        entityCommandInformation.openRecordInDialog.get()
                            ? PageManager.instance?.openPageAsDialogAsync(entityCommandInformation.createEntityUrl(), { isSoftDeleted: !!(record?.deletedGuid) })
                            : PageManager.instance?.navigateAsync(entityCommandInformation.createEntityUrl(), null, null, { isSoftDeleted: !!(record?.deletedGuid) })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

